module.exports = __webpack_public_path__ + "static/media/Credit_Card_Logos@3x.0fdb64f2.png";